import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { makeDefaultMenuOrder } from "../menu/makeDefaultMenuOrder";
import { CATALOGUENAMES } from "../../constants";
export var mapProduct = function mapProduct(productElement) {
  var locationId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "annarbor-mi";
  var productPoints = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var wishListProducts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var listPriceBool = Boolean(productElement.ListPrice);
  var baseCalBool = Boolean(parseInt(productElement.BaseCalories));
  var options = makeDefaultMenuOrder(productElement, locationId);
  var defaultOption = options.map(function (option) {
    return _objectSpread(_objectSpread({}, option), {}, {
      "catalogName": CATALOGUENAMES[productElement.CatalogName] || null
    });
  });

  var customCalorie = function customCalorie() {
    var baseCal = parseInt(productElement.BaseCalories) / 10;

    if (productElement.ShowCaloriePerServing) {
      if (productElement.IsEat && Boolean(productElement.OptionsExists)) {
        return "".concat(productElement.BaseCalories, " cal + choices");
      } else if (productElement.IsEat && Boolean(!productElement.OptionsExists)) {
        return "".concat(productElement.BaseCalories, " cal");
      } else if (productElement.IsCater && Boolean(productElement.OptionsExists)) {
        return "Starting at ".concat(productElement.BaseCalories, " cal (").concat(Math.round(baseCal / 10) * 10, "/Serving)");
      } else if (productElement.IsCater && Boolean(!productElement.OptionsExists)) {
        return "".concat(productElement.BaseCalories, " cal (").concat(Math.round(baseCal / 10) * 10, "/Serving)");
      } else {
        return "".concat(productElement.BaseCalories, " cal");
      }
    } else {
      return "".concat(productElement.BaseCalories, " cal");
    }
  };

  var pegPointsNeeded = productPoints === null || productPoints === void 0 ? void 0 : productPoints.filter(function (product) {
    var _product$productChain, _productElement$Produ;

    return ((_product$productChain = product.productChainId) === null || _product$productChain === void 0 ? void 0 : _product$productChain.toString()) === ((_productElement$Produ = productElement.ProductChainId) === null || _productElement$Produ === void 0 ? void 0 : _productElement$Produ.toString());
  });
  var isFavorite = wishListProducts.some(function (wishListProduct) {
    return wishListProduct.ProductChainId === productElement.ProductChainId;
  });
  return {
    image: {
      'value': {
        'src': productElement.ImageFilePath,
        'alt': productElement.DisplayName,
        'title': productElement.DisplayName
      }
    },
    link: {
      value: {
        'text': 'Customize',
        'title': 'Customize',
        'href': "".concat(productElement.DetailLink),
        'class': 'cb-button-secondary'
      }
    },
    link2: {
      value: {
        'text': 'Add to Order',
        'title': 'Add to Order',
        'href': '#',
        'class': 'cb-button-primary'
      }
    },
    link3: {
      value: {
        'text': productElement.IsRetail ? "View Detail" : 'Customize',
        'title': productElement.IsRetail ? "View Detail" : 'Customize',
        'href': "".concat(productElement.DetailLink),
        'class': 'cb-button-primary'
      }
    },
    title: {
      value: productElement.DisplayName
    },
    subtitle: {
      value: ""
    },
    text: {
      value: productElement.ShortDescription
    },
    cardColor: {
      fields: {
        value: {
          value: 'color1'
        }
      }
    },
    price: {
      value: listPriceBool && productElement.ListPrice === productElement.AdjustedPrice ? "".concat(listPriceBool ? "$".concat(productElement.ListPrice.toFixed(2)) : "") : listPriceBool ? "<strike>$".concat(productElement.ListPrice.toFixed(2), "</strike> $").concat(productElement.AdjustedPrice.toFixed(2)) : ""
    },
    calorie: {
      value: baseCalBool ? customCalorie() : ""
    },
    likes: {
      value: ""
    },
    linkType: {
      value: 'default'
    },
    available: {
      value: "".concat(!!productElement.Availability ? productElement.Availability : "")
    },
    tags: productElement.Tags,
    lighterFare: productElement.LighterFare,
    servingSize: productElement.ServingSize,
    productId: productElement.ProductChainId,
    isFavorite: isFavorite,
    defaultOptions: defaultOption,
    fullElement: productElement,
    optionsExist: productElement.OptionsExists,
    isRetail: productElement.isRetail,
    catalogName: CATALOGUENAMES[productElement.CatalogName],
    advanceLeadtime: (productElement === null || productElement === void 0 ? void 0 : productElement.LeadTimeInfo) || '',
    pegPointsNeeded: (pegPointsNeeded === null || pegPointsNeeded === void 0 ? void 0 : pegPointsNeeded.length) ? pegPointsNeeded[0] : null
  };
};
export var mapProductRetail = function mapProductRetail(productElement, noButton) {
  var _productElement$Image, _productElement$Image2, _productElement$Image3, _productElement$Image4;

  var listPriceBool = Boolean(productElement.ListPrice);
  var saleActive = productElement.ListPrice === productElement.AdjustedPrice;

  var handleImageGet = function handleImageGet(imageObj) {
    return Boolean(imageObj) && validURL(imageObj.SwatchUrl) ? imageObj.SwatchUrl : undefined;
  };

  var swatches = productElement.Variants.map(function (variant) {
    return Array.isArray(variant.Images) ? handleImageGet(variant.Images[0]) : undefined;
  }).filter(Boolean);
  var variantsExist = Boolean(productElement.Variants.length);

  var checkBannerVariants = function checkBannerVariants() {
    var variants = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var mapped = variants.reduce(function (acc, next) {
      if (acc === true) return acc;
      if (next.StockStatusName) return true;
      return false;
    }, false);
    return mapped;
  };

  var sum = function sum(array, key) {
    return array.reduce(function (a, b) {
      return a + (b[key] || 0);
    }, 0);
  };

  var hasZeroInv = variantsExist ? sum(productElement.Variants, "AvailableInventory") : productElement.AvailableInventory;
  var almostGoneBanner = variantsExist ? checkBannerVariants(productElement.Variants) : Boolean(productElement.StockStatusName === "Almost Gone");
  var model = {
    "image": {
      "value": {
        "src": Array.isArray(productElement.Images) && productElement.Images.length ? (_productElement$Image = productElement.Images[0]) === null || _productElement$Image === void 0 ? void 0 : _productElement$Image.ImageUrl : getImageSrc(productElement.Image),
        "alt": (productElement === null || productElement === void 0 ? void 0 : (_productElement$Image2 = productElement.Image) === null || _productElement$Image2 === void 0 ? void 0 : _productElement$Image2.Alt) || productElement.DisplayName,
        "title": (productElement === null || productElement === void 0 ? void 0 : (_productElement$Image3 = productElement.Image) === null || _productElement$Image3 === void 0 ? void 0 : _productElement$Image3.Alt) || productElement.DisplayName
      }
    },
    "link2": {
      "value": {
        'text': 'Add to Cart',
        'title': 'Add to Cart',
        'href': '#',
        'class': 'cb-button-primary'
      }
    },
    "link3": {
      "value": {
        "text": "Choose Options",
        "title": "Add to Order",
        "href": productElement.DetailLink || productElement.CategoryContentPagePath || "/shop/category/sub/productdetail",
        "class": "cb-button-primary"
      }
    },
    "title": {
      "value": productElement.DisplayName
    },
    "subtitle": {
      "value": ""
    },
    "text": {
      "value": ""
    },
    "linkType": {
      "value": "default"
    },
    "color": {
      "value": "color1"
    },
    "price": {
      value: listPriceBool && saleActive ? "".concat(listPriceBool ? "$".concat(productElement.ListPrice.toFixed(2)) : "") : listPriceBool ? "<strike>$".concat(productElement.ListPrice.toFixed(2), "</strike> $").concat(productElement.AdjustedPrice.toFixed(2)) : ""
    },
    "calorie": {
      "value": ""
    },
    "likes": {
      "value": ""
    },
    "available": {
      "value": ""
    },
    "defaultOptions": [{
      "options": variantsExist ? [123] : [],
      "StoreProductId": null,
      "ProductChainId": productElement.ProductId,
      "VariantId": "",
      "storeId": null,
      "Quantity": 1,
      "imageUrl": Array.isArray(productElement.Images) ? (_productElement$Image4 = productElement.Images[0]) === null || _productElement$Image4 === void 0 ? void 0 : _productElement$Image4.ImageUrl : getImageSrc(productElement.Image),
      "total": saleActive ? productElement.ListPrice : productElement.AdjustedPrice,
      "displayName": productElement.DisplayName,
      "catalogName": CATALOGUENAMES[productElement.CatalogName] || null
    }],
    "tags": "",
    "lighterFare": false,
    "servingSize": "",
    //Probably need to update these keys
    almostGoneBanner: almostGoneBanner,
    exclusiveBanner: false,
    exclusiveText: productElement.IsExclusive,
    sku: productElement.ProductId,
    isFavourite: productElement.IsFavourite,
    noButton: noButton,
    swatches: swatches,
    fullElement: productElement,
    variantsExist: variantsExist,
    hasZeroInv: hasZeroInv,
    catalogName: CATALOGUENAMES[productElement.CatalogName]
  };
  return model;
};

var getImageSrc = function getImageSrc() {
  var imageObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return imageObj.Src || "";
};

var validURL = function validURL(str) {
  var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
  '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

  return !!pattern.test(str);
};